import matchPath from './matchPath';
// this is a fork from react-router-config
function computeRootMatch(pathname) {
    return { path: '/', url: '/', params: {}, isExact: pathname === '/' };
}
function matchRouteToPath(route, pathname, allowRoot, branch) {
    if (route.path) {
        return matchPath(pathname, route);
    }
    if (branch.length) {
        return branch[branch.length - 1].match; // use parent match
    }
    if (allowRoot) {
        return computeRootMatch(pathname); // use default "root" match
    }
    return null;
}
function matchRoutesRecursive(routes, pathname, allowRoot, branch) {
    routes.some(function (route) {
        var match = matchRouteToPath(route, pathname, allowRoot, branch);
        if (match) {
            branch.push({ route: route, match: match });
            if (route.routes) {
                matchRoutesRecursive(route.routes, pathname, allowRoot, branch);
            }
        }
        return !!match;
    });
    return branch;
}
export default function matchRoutes(routes, pathname, allowRoot) {
    if (allowRoot === void 0) { allowRoot = true; }
    return matchRoutesRecursive([].concat(routes), pathname, allowRoot, []);
}
//# sourceMappingURL=matchRoutes.js.map